import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const DataTable = ({ rows, columns, setEditableRowId, onRowClick }) => {
  const handleRowEdit = async (updatedRow) => {
    let editObj = {};
  
    // Prepare update object with only changed fields
    if (updatedRow.name !== undefined) {
      editObj["guest_info.guest_name"] = updatedRow.name;
    }
    if (updatedRow.contact !== undefined) {
      editObj["guest_info.guest_phone"] = updatedRow.contact;
    }
    if (updatedRow.bookingDate !== undefined) {
      editObj["booking_date"] = updatedRow.bookingDate;
    }
    if (updatedRow.tourDate !== undefined) {
      editObj["travel_date"] = updatedRow.tourDate;
    }
    if (updatedRow.cost !== undefined) {
      editObj["cost"] = updatedRow.cost;
    }
  
    return updatedRow; // This is important for DataGrid to finalize the edit
  };
  
  return (
    // <div >
     
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10]}
        onRowClick={(params, event) => {
          if (
            event.target.closest('button') ||
            event.target.closest('.MuiSwitch-root') ||
            event.target.closest('input') ||
            event.target.closest('.MuiIconButton-root') ||
            event.target.closest('a')
          ) {
            return;
          }
          if (onRowClick) onRowClick(params, event);
        }}
        processRowUpdate={(newRow) => {
          if (setEditableRowId) setEditableRowId(null); // Stop editing after update
          handleRowEdit(newRow)
          return newRow;
        }}
        experimentalFeatures={{ newEditingApi: true }}
        editMode="row"
        sx={{
          backgroundColor: 'white',
          borderRadius: 2,
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
          border: '1px solid #e0e0e0',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#f5f7fa',
            color: '#333',
            fontSize: '1rem',
            fontWeight: 'bold',
          },
          '& .MuiDataGrid-row': {
            cursor: onRowClick ? 'pointer' : 'default',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#f8fafc',
          },
        }}
      />
    // </div>
  );
};

export default DataTable;
